import React, {useEffect, useState} from 'react';
import {Helmet} from "react-helmet";
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../components/Portlet";
import {Link} from "react-router-dom";
import {TouristServicesEditRoute, TripCheckEditRoute} from "../../routesConstants";
import numberFormat from "../../../helpers/numberFormat";
import DataTable from "../../../components/dataTable";
import LoadingButton from "../../base/components/loadingButton";
import axios from "../../../helpers/axios";
import {useNavigate} from "react-router";

const TripCheckList = () => {
  const [data, setData] = useState()
  const [loading, setLoading] = useState()
  const [query, setQuery] = useState({})
  const navigate = useNavigate()
  const columns = [
    {
      Header: 'Название',
      accessor: 'name',
      Cell: ({value,row})=>(
        <Link to={TripCheckEditRoute + row.original.id}>
          {value}
        </Link>
      )
    },
    {
      Header: 'Создан',
      accessor: 'createdBy',
    },
    {
      Header: 'Когда',
      accessor: 'createdAt',
    },
    {
      Header: "Проверено",
      accessor: "checkedItems",
      Cell: ({ value, row }) => {
        return (
          <div className={'d-flex justify-content-start align-items-center gap-2'}>
            {value}/{row.original.totalItems}
            <i className={`fa fa-circle text-${value !== row.original.totalItems? 'danger' : 'success'}`}/>
          </div>
        )
      }
    },
  ]

  const createNewItem = () =>{
    setLoading(true)
    axios.put('/api/tripCheck/',{name:'Ваше название'})
      .then(({data})=>{
        navigate(TripCheckEditRoute+data.id)
      })
      .finally(()=>setLoading(false))
  }

  return (
    <>
      <Helmet>
        <title>Чек-лист поездок</title>
      </Helmet>
      <Portlet>
        <PortletHeader title={'Чек-лист поездок'} toolbar={<PortletHeaderToolbar>
          <LoadingButton loading={loading} onClick={createNewItem} title={"Добавить"}/>
        </PortletHeaderToolbar>}/>
        <PortletBody>
          <DataTable columns={columns}
                     search={query}
                     itemsPerPage={20}
                     url={`/api/tripCheck/`}/>
        </PortletBody>
      </Portlet>
    </>
  );
};

export default TripCheckList;
